import {alias, createModelSchema} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {ItemKey} from "../item/core/ItemKey";
import {GuardConfig} from "../guard/GuardConfig";
import {RewardModel} from "../reward/RewardModel";


export class ItemSocial extends BaseObject {

    constructor() {
        super();

        this._key = null;

        this._rarity = 0;
        this._guard = new GuardConfig();
        this._playerReward = new RewardModel();
        this._friendReward = new RewardModel();
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get playerReward() {
        return this._playerReward;
    }

    set playerReward(value) {
        this._playerReward = value;
    }

    get friendReward() {
        return this._friendReward;
    }

    set friendReward(value) {
        this._friendReward = value;
    }

    valid() {

        if (!this.key || !this.key.valid() || this.key.any()) {
            return false;
        }

        if (!Number.isInteger(this.rarity) || this.rarity <= 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.playerReward && !this.playerReward.valid()) {
            return false;
        }

        if (this.friendReward && !this.friendReward.valid()) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemSocial());
        } else if (target instanceof ItemSocial) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemSocial, {
    _key: alias("key", ItemKey.schema()),
    _enabled: alias("enabled", Schema.primitive()),

    _rarity: alias("rarity", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _playerReward: alias("player_reward", RewardModel.schema()),
    _friendReward: alias("friend_reward", RewardModel.schema())
});